import { connect } from 'react-redux';

import { isAuth } from 'containers/authorization/selectors';

import PrivatableRoute from './component';

export default connect((state) => ({ auth: isAuth(state) }))(PrivatableRoute);
